export default __webpack_public_path__ + "static/media/3-6-09-bowie.261a541f.m4a";